import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    data:{}
   
    
}
const mutations={


    getGroupUserIndex(state,value){
        
        

        post(urls.admin.product_group_user.index,value).then((result)=>{

          state.result=result
         

          
       
        
       
           
        });
        
    },

    addProductGroupUser(state,value){



        post(urls.admin.product_group_user.add,value).then((result)=>{

            state.result=result







        });

    },

    deleteProductGroupUser(state,value){

        post(urls.admin.product_group_user.delete,value).then((result)=>{

            state.result=result

        });

    },





}
const  actions={
    getGroupUserIndexAction(context,value){
       
        context.commit("getGroupUserIndex",value)
       
    },

    addProductGroupUserAction(context,value){

        context.commit("addProductGroupUser",value)

    },
    deleteProductGroupUserAction(context,value){

        context.commit("deleteProductGroupUser",value)

    },

   

}

export default {state,mutations,actions}